/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './hospital-op-bill-item.reducer';

export const HospitalOPBillItemDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const hospitalOPBillItemEntity = useAppSelector(state => state.hospitalOPBillItem.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="hospitalOPBillItemDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.hospitalOPBillItem.detail.title">HospitalOPBillItem</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.hospitalOPBillItem.id">Id</Translate>
            </span>
          </dt>
          <dd>{hospitalOPBillItemEntity.id}</dd>
          <dt>
            <span id="description">
              <Translate contentKey="tinyMedicRestApp.hospitalOPBillItem.description">Description</Translate>
            </span>
          </dt>
          <dd>{hospitalOPBillItemEntity.description}</dd>
          <dt>
            <span id="totalCost">
              <Translate contentKey="tinyMedicRestApp.hospitalOPBillItem.totalCost">Total Cost</Translate>
            </span>
          </dt>
          <dd>{hospitalOPBillItemEntity.totalCost}</dd>
          <dt>
            <span id="paidAmount">
              <Translate contentKey="tinyMedicRestApp.hospitalOPBillItem.paidAmount">Paid Amount</Translate>
            </span>
          </dt>
          <dd>{hospitalOPBillItemEntity.paidAmount}</dd>
          <dt>
            <span id="discount">
              <Translate contentKey="tinyMedicRestApp.hospitalOPBillItem.discount">Discount</Translate>
            </span>
          </dt>
          <dd>{hospitalOPBillItemEntity.discount}</dd>
          <dt>
            <span id="billType">
              <Translate contentKey="tinyMedicRestApp.hospitalOPBillItem.billType">Bill Type</Translate>
            </span>
          </dt>
          <dd>{hospitalOPBillItemEntity.billType}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.hospitalOPBillItem.active">Active</Translate>
            </span>
          </dt>
          <dd>{hospitalOPBillItemEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.hospitalOPBillItem.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{hospitalOPBillItemEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.hospitalOPBillItem.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{hospitalOPBillItemEntity.timestampEntry}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.hospitalOPBillItem.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{hospitalOPBillItemEntity.lastUpdated}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.hospitalOPBillItem.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{hospitalOPBillItemEntity.cursor}</dd>
          <dt>
            <span id="miscellaneous">
              <Translate contentKey="tinyMedicRestApp.hospitalOPBillItem.miscellaneous">Miscellaneous</Translate>
            </span>
          </dt>
          <dd>{hospitalOPBillItemEntity.miscellaneous ? 'true' : 'false'}</dd>
          <dt>
            <span id="multiplier">
              <Translate contentKey="tinyMedicRestApp.hospitalOPBillItem.multiplier">Multiplier</Translate>
            </span>
          </dt>
          <dd>{hospitalOPBillItemEntity.multiplier}</dd>
          <dt>
            <span id="qty">
              <Translate contentKey="tinyMedicRestApp.hospitalOPBillItem.qty">Qty</Translate>
            </span>
          </dt>
          <dd>{hospitalOPBillItemEntity.qty}</dd>
          <dt>
            <span id="chargedMrp">
              <Translate contentKey="tinyMedicRestApp.hospitalOPBillItem.chargedMrp">Charged Mrp</Translate>
            </span>
          </dt>
          <dd>{hospitalOPBillItemEntity.chargedMrp}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.hospitalOPBillItem.bill">Bill</Translate>
          </dt>
          <dd>{hospitalOPBillItemEntity.bill ? hospitalOPBillItemEntity.bill.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.hospitalOPBillItem.appointment">Appointment</Translate>
          </dt>
          <dd>{hospitalOPBillItemEntity.appointment ? hospitalOPBillItemEntity.appointment.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.hospitalOPBillItem.labBill">Lab Bill</Translate>
          </dt>
          <dd>{hospitalOPBillItemEntity.labBill ? hospitalOPBillItemEntity.labBill.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.hospitalOPBillItem.opService">Op Service</Translate>
          </dt>
          <dd>{hospitalOPBillItemEntity.opService ? hospitalOPBillItemEntity.opService.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.hospitalOPBillItem.pharmacyBill">Pharmacy Bill</Translate>
          </dt>
          <dd>{hospitalOPBillItemEntity.pharmacyBill ? hospitalOPBillItemEntity.pharmacyBill.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.hospitalOPBillItem.order">Order</Translate>
          </dt>
          <dd>{hospitalOPBillItemEntity.order ? hospitalOPBillItemEntity.order.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.hospitalOPBillItem.orderItem">Order Item</Translate>
          </dt>
          <dd>{hospitalOPBillItemEntity.orderItem ? hospitalOPBillItemEntity.orderItem.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.hospitalOPBillItem.patientCategory">Patient Category</Translate>
          </dt>
          <dd>{hospitalOPBillItemEntity.patientCategory ? hospitalOPBillItemEntity.patientCategory.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.hospitalOPBillItem.miscCharge">Misc Charge</Translate>
          </dt>
          <dd>{hospitalOPBillItemEntity.miscCharge ? hospitalOPBillItemEntity.miscCharge.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.hospitalOPBillItem.scheme">Scheme</Translate>
          </dt>
          <dd>{hospitalOPBillItemEntity.scheme ? hospitalOPBillItemEntity.scheme.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/hospital-op-bill-item" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/hospital-op-bill-item/${hospitalOPBillItemEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default HospitalOPBillItemDetail;
